import { Events, Linked } from "@type-r/models";
import React from "react";
import { CommentDialog } from "./comment";
import { PromiseToPayDialog } from "./promiseToPay";
import { DisputeDialog } from "./dispute";
import { InternalStatusSocDialog } from "./internal-status";
import { PopupIODialog, PrimaryButton, SelectFile } from "lqx-react/lib";
import { useLinked } from "@type-r/react";
import { localUserInfo } from "api";

export type SocDialogType = 'promiseToPay' | 'comment' | 'dispute' | 'approve' | 'internalStatus';

export const ShowSocDialog = ({
    $dialog,
    model,
    hasCustomerApproverAccess,
    hasCustomerWriteAccess,
    hasSupplierApproverAccess,
    hasSupplierWriteAccess,
    hasSuperSupplierAccess }: {
        $dialog: Linked<SocDialogType>,
        model: any,
        hasCustomerApproverAccess: Boolean,
        hasCustomerWriteAccess: Boolean,
        hasSupplierApproverAccess: Boolean,
        hasSupplierWriteAccess: Boolean,
        hasSuperSupplierAccess: Boolean
    }) => {
    switch ($dialog.value) {
        case 'promiseToPay':
            return <PromiseToPayDialog
                $isOpen={$dialog.equals('promiseToPay')}
                invoices={model}
            />;
        case 'comment':
            return <CommentDialog
                $isOpen={$dialog.equals('comment')}
                invoices={model}
            />;
        case 'dispute':
            return <DisputeDialog
                $isOpen={$dialog.equals('dispute')}
                invoices={model}
                hasCustomerApproverAccess={hasCustomerApproverAccess}
                hasCustomerWriteAccess={hasCustomerWriteAccess}
                hasSupplierApproverAccess={hasSupplierApproverAccess}
                hasSupplierWriteAccess={hasSupplierWriteAccess}
                hasSuperSupplierAccess={hasSuperSupplierAccess}
                dialogType='dispute'
            />;
        case 'approve':
            return <DisputeDialog
                $isOpen={$dialog.equals('approve')}
                invoices={model}
                hasCustomerApproverAccess={hasCustomerApproverAccess}
                hasCustomerWriteAccess={hasCustomerWriteAccess}
                hasSupplierApproverAccess={hasSupplierApproverAccess}
                hasSupplierWriteAccess={hasSupplierWriteAccess}
                hasSuperSupplierAccess={hasSuperSupplierAccess}
                dialogType='approve'
            />;
        case 'internalStatus':
            return <InternalStatusSocDialog
                $isOpen={$dialog.equals('internalStatus')}
                invoices={model}
            />;
        default:
            return <div />;
    }
}


export const UploadSoaButton = () => {
  
    const $isOpen = useLinked(false);
  
    return (
        <>
          <PrimaryButton color="blue" onClick={$isOpen.true} style={{ width: 90, marginBottom: 6 }} >Upload SOA</PrimaryButton>
          {$isOpen.value ? <UploadSoaDialog $isOpen={$isOpen} /> : null}
        </>
    )
  };
  
  const UploadSoaDialog = ({ $isOpen }: {
    $isOpen: Linked<boolean>
  }) => {
    const $file = useLinked(null);
    const file = $file.value;
  
    const uploadSoa = async () => {
      const url = '/api/v2/invoice-management/statement-of-customer/upload-statement';
  
      const formData = new FormData();
      formData.append("upfile", file, file.name);
  
      var resp = await fetch(url, {
        method: 'POST',
        headers: new Headers({
          "Authorization": "Bearer " + localUserInfo.token
        }),
        body: formData
      });

      Events.trigger('cpUpload:done');
    }
  
    return (
      <PopupIODialog
        title="Statement of Account"
        $isOpen={$isOpen}
        actionLabel="Yes"
        success={'Upload Done'}
        disabled={!file}
        doIO={uploadSoa}
      >
        Please select the file to upload.
        <SelectFile accept=".xlsx" label="Attachment" $value={$file} />
      </PopupIODialog>
    );
  };